// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QcgC","list":"styles_list__1BfEd","disableSelection":"styles_disableSelection__TI98j"};